import React from 'react';
import { Wallet, Heart, BookOpen, Search, ListChecks, ThumbsUp } from 'lucide-react';

export const BenefitsGrid = () => {
  const benefits = [
    {
      icon: Wallet,
      title: 'Maximize Your Revenue',
      description: 'Our #1 goal is to get you the reimbursement you are entitled to – in a timely manner.'
    },
    {
      icon: Heart,
      title: 'Focus on Patient Care',
      description: 'Let us handle the billing complexities so you can focus on what matters most - your patients.'
    },
    {
      icon: BookOpen,
      title: 'Stay Compliant',
      description: 'We keep you updated with the latest changes in billing, coding, and documentation requirements.'
    },
    {
      icon: Search,
      title: 'Complete Transparency',
      description: 'We work closely with our clients to address and fulfill their ever changing needs.'
    },
    {
      icon: ListChecks,
      title: 'Streamlined Processes',
      description: 'Our highly defined processes are dedicated to improving reimbursement through accurate billing.'
    },
    {
      icon: ThumbsUp,
      title: 'Personalized Service',
      description: 'The personalized attention of a small company with the support and experience of a larger one.'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-navy-700 via-navy-600 to-teal-700 relative overflow-hidden">
      {/* Background pattern */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `radial-gradient(circle, #40E0D0 1.5px, transparent 1.5px)`,
          backgroundSize: '28px 28px'
        }}
      />
      
      {/* Gradient orbs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-teal-400/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-navy-400/20 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Why Choose Capital Billing Services?
          </h2>
          <p className="text-lg text-gray-300">
            We are dedicated to meeting the needs of your practice and offering cost-effective solutions to your collection systems.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="group bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 hover:border-teal-400/40 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-teal-400/20 to-teal-500/10 flex items-center justify-center mb-4 group-hover:from-teal-400/30 group-hover:to-teal-500/20 transition-all duration-300 border border-teal-400/20">
                  <Icon className="w-7 h-7 text-teal-400" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-teal-300 transition-colors">{benefit.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed group-hover:text-gray-300 transition-colors">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
